import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Picture } from './models/picture.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  @Input() pictures: Picture[];
  @Input() loadingUrl: string;
  @Output() onPictureClick = new EventEmitter<Picture>();
  currentIndex = 0;

  constructor() { }

  ngOnInit() {
  }

  next() {
    if (this.currentIndex === this.pictures.length - 1) {
      return;
    }
    this.currentIndex++;
    this.slideGallery();
  }

  previous() {
    if (this.currentIndex === 0) {
      return;
    }
    this.currentIndex--;
    this.slideGallery();
  }

  slideGallery() {
    for (let i = 0; i < this.pictures.length; i++) {
      const isOpac = i === this.currentIndex ? 1 : 0;
      const elem = $(`#${i}`);
      elem.css({ opacity: 0 });
      elem.css({ transform: `translate3d(-${(100 * this.currentIndex)}%, 0px, 0px)`, opacity: isOpac });
    }
  }

  goTo(index: number) {
    if (index === this.currentIndex) {
      return;
    }
    this.currentIndex = index;

    this.slideGallery();
  }

  pictureClick(picture: Picture) {
    this.onPictureClick.emit(picture);
  }

}
